import {InputText} from "primereact/inputtext";
import {useEffect, useState} from "react";

/**
 * Hält den Wert lokal und ruft onChange erst beim Verlassen des Felds auf.
 * @param {object} props
 * @param {string} [props.id]
 * @param {React.Ref<any>} [props.ref]
 * @param {*} [props.value]
 * @param {string} [props.className]
 * @param {boolean} [props.hasAssociatedOutput]
 * @param {boolean} [props.disabled]
 * @param {(e: React.FocusEvent<HTMLInputElement>) => void} props.onChange
 * @param {string} [props.placeholder]
 * @param {(e: React.FocusEvent<HTMLInputElement>) => void} [props.onBlur]
 * @param {React.CSSProperties} [props.style]
 * @param {"left"|"right"|"center"} [props.textAlign]
 * @return {React.ReactNode}
 */
export default function InputTextField({
    id,
    ref,
    value,
    className,
    hasAssociatedOutput,
    disabled,
    onChange,
    placeholder,
    onBlur,
    style,
    textAlign = "right",
}) {
    const [localValue, setLocalValue] = useState(value);

    useEffect(() => {
        setLocalValue(value);
    }, [value]);

    return (
        <InputText
            id={id}
            ref={ref}
            className={`w-full ${className} ${hasAssociatedOutput ? ` indication-filled-placeholder` : ""}`}
            value={localValue || ""}
            disabled={disabled}
            onChange={(e) => setLocalValue(e.target.value || null)}
            onBlur={(e) => {
                if (typeof onBlur === "function") {
                    onBlur(e);
                }
                if (e.target.value === value) {
                    return;
                }
                return onChange(e);
            }}
            placeholder={placeholder}
            style={{...style, textAlign}}
            data-pr-position="top"
        />
    );
}
